import i18next from 'i18next';
import { FollowUpCompleted } from 'infrastructure/enums';

export interface IFollowUpCompletedItem {
  id: FollowUpCompleted | null;
  name: string;
}

export const followUpCompletedDataSource = (
  withNone = true,
): IFollowUpCompletedItem[] => {
  const dataSource: IFollowUpCompletedItem[] = [
    {
      id: FollowUpCompleted.Yes,
      name: i18next.t('labels.yes'),
    },
    {
      id: FollowUpCompleted.No,
      name: i18next.t('labels.no'),
    },
  ];

  if (withNone) {
    dataSource.unshift({
      id: null,
      name: i18next.t('labels.all'),
    });
  }

  return dataSource;
};
